import {
  createIndustryDisplayList,
  IndustryData,
} from 'logics/createIndustryInitialList';
import { ChangeEvent, useState } from 'react';

/**
 * 業種のカスタムフック
 * @param initialIndustryList
 * @returns 業種の値と更新する関数を含むオブジェクト
 */
export const useIndustry = (initialIndustryList: IndustryData[]) => {
  const [industryDisplayList, setIndustryDisplayList] =
    useState<IndustryData[]>(initialIndustryList);
  const industryLList = industryDisplayList;
  const industrySList = industryDisplayList.flatMap(
    (industry) => industry.industrySList
  );

  // 選択中の大分類のid配列
  const selectedIndustryLIdList = industryLList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 選択中の小分類のid配列
  const selectedIndustrySIdList = industrySList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 大分類のチェックボックス更新処理
  const updateIsCheckedIndustryLList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = industryLList.map((industry) => {
      if (industry.id !== selectedId) return industry;
      return {
        ...industry,
        isChecked: event.target.checked,
      };
    });

    const checkedIndustryDisplayList: IndustryData[] =
      createIndustryDisplayList(checkedList, industrySList);
    setIndustryDisplayList(checkedIndustryDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // 小分類のチェックボックス更新処理
  const updateIsCheckedIndustrySList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = industrySList.map((industry) => {
      if (industry.id !== selectedId) return industry;

      return {
        ...industry,
        isChecked: event.target.checked,
      };
    });

    const checkedIndustryDisplayList: IndustryData[] =
      createIndustryDisplayList(industryLList, checkedList);
    setIndustryDisplayList(checkedIndustryDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // チェック状態クリア処理
  const clearIsCheckIndustryList = () => {
    setIndustryDisplayList([]);
  };

  return {
    industryDisplayList,
    setIndustryDisplayList,
    selectedIndustryLIdList,
    selectedIndustrySIdList,
    clearIsCheckIndustryList,
    updateIndustryFunctions: {
      updateIsCheckedIndustryLList,
      updateIsCheckedIndustrySList,
    },
  };
};
